export enum HeadingSizeEnum {
	SMALL = 'SMALL',
	MEDIUM = 'MEDIUM',
	LARGE = 'LARGE',
	EXTRA_LARGE = 'EXTRA_LARGE',
}

export enum FinePrintEnum {
	CAPTION = 'CAPTION',
	OVERLINE = 'OVERLINE',
	TINY = 'TINY',
}

export enum MarginSizeEnum {
	NONE = '0px',
	SMALL = '8px',
	DEFAULT = '16px',
}

export enum AlignmentEnum {
	LEFT = 'left',
	CENTER = 'center',
	RIGHT = 'right',
}

export enum WeightEnum {
	REGULAR = 'regular',
	MEDIUM = 'medium',
	SEMIBOLD = 'semibold',
	BOLD = 'bold',
}

export enum ColorVariantEnum {
	DARK = 'dark',
	MEDIUM = 'medium',
	LIGHT = 'light',
	DISABLED = 'disabled',
	INFO = 'info',
	SUCCES = 'succes',
	WARNING = 'warning',
	ERROR = 'error',
	BLACK = 'black',
	WHITE = 'white',
}

export interface IText {
	colorVariant?: ColorVariantEnum | ColorVariantEnum[];
	margin?: MarginSizeEnum;
	alignment?: AlignmentEnum;
	weight?: WeightEnum;
	underline?: boolean;
	withEllipsis?: boolean;
	noLineHeight?: boolean;
}

export interface IHeading extends IText {
	size: HeadingSizeEnum;
}

export interface IFinePrint extends IText {
	type: FinePrintEnum;
}

export interface ILink {
	colorVariant?: ColorVariantEnum;
}

export interface ITextAtom {
	Heading: IHeading;
	Title: IText;
	SubTitle: IText;
	Paragraph: IText;
	FinePrint: IFinePrint;
}
